<template>
  <div class="add-box">
    <el-form ref="deptform" :model="deptform" label-width="120px" class="user-form">
      <el-form-item label="部门名称:">
        <el-input v-model="deptform.name" placeholder="部门名称" class="user-input" />
      </el-form-item>

      <el-form-item label="上级部门:">
        <el-cascader
          ref="lastdept"
          :show-all-levels="false"
          :options="lastdeptList"
          :props="optionProps"
          class="user-input"
          :placeholder="deptform.parentName"
          @change="handleItemChange"
        />
      </el-form-item>

      <el-form-item label="排序号:">
        <el-input-number
          v-model="deptform.orderNum"
          :min="0"
          :max="1000"
          class="user-input"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.prevent="save">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lastdeptList: [],

      optionProps: {
        expandTrigger: 'hover',
        value: 'deptId',
        label: 'name',
        children: 'children'
      },

      deptform: {
        name: '',
        orderNum: 0,
        parentId: 0,
        parentName: '一级部门'
      }
    }
  },

  created() {
    this.$emit('setCurrentMenu', '部门管理')
    this.getlastdept()
  },

  methods: {
    getlastdept() {
      const vm = this
      vm.axios
        .get(vm.homePath() + '/sys/dept/select')
        .then((res) => {
          if (res.data.status === '000000') {
            const data = res.data.deptList
            vm.lastdeptList = vm.filterNull(vm.toTreeData(data, 'parentId', 'deptId'))
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch(error => console.log(error))
    },

    filterNull(data) {
      const vm = this
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          data[i].children = undefined
        } else {
          vm.filterNull(data[i].children)
        }
      }
      return data
    },

    handleItemChange(val) {
      this.deptform.parentId = val
      this.deptform.parentName = this.$refs['lastdept'].getCheckedNodes()[0].label
    },

    save() {
      let past = true
      if (this.deptform.name === '') {
        this.$alert('部门名称', '提示')
        past = false
      }

      if (past) {
        const vm = this
        vm.axios
          .post(vm.homePath() + '/sys/dept/save', {
            name: vm.deptform.name,
            parentId: vm.deptform.parentId,
            parentName: vm.deptform.parentName,
            orderNum: vm.deptform.orderNum
          })
          .then((response) => {
            if (response.data.status === '000000') {
              vm.$alert('增加成功', '提示', {
                callback: (action) => {
                  vm.$router.push('/index/dept')
                }
              })
            } else {
              console.log(response.data.message)
            }
          })
          .catch((error) => console.log(error))
      }
    },

    back() {
      this.$router.push('/index/dept')
    }
  }
}
</script>

<style></style>
